import { render, staticRenderFns } from "./OfficeDetail.vue?vue&type=template&id=7875a332&scoped=true&"
import script from "./OfficeDetail.vue?vue&type=script&lang=js&"
export * from "./OfficeDetail.vue?vue&type=script&lang=js&"
import style0 from "./OfficeDetail.vue?vue&type=style&index=0&id=7875a332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7875a332",
  null
  
)

export default component.exports